import React from 'react'
import './Footerw.css'

export const Footerw = () => {
  return (
    <div className='all-footer'>
        <p>Copyright (C) 2022 DigitalLAB. Todos los Derechos Reservados.</p>
        <div className='footer-line'></div>
        <a href='https://brayanleyva.netlify.app/' target='_blank'>Made by Brayan Leyva Gastelum</a>
    </div>
  )
}
